import { DiscussionType } from "@cnx/common";
import { getDraftTitle } from "utils/chat";
import { useChatContextStore } from "../providers/ChatContextProvider";

export const useChatFeature = () => {
  const { discussion, discussionContext, contextId } = useChatContextStore();

  const title = discussion?.title ?? getDraftTitle(discussionContext);
  const stopActivityKind =
    discussion?.stopActivityKind ?? discussionContext?.activityKind;
  const discussionType = discussion?.discussionType ?? DiscussionType.CONTEXT;
  const showHeader = !!discussion || (!!discussionContext && !!contextId);

  return {
    title,
    stopActivityKind,
    discussionType,
    showHeader,
  };
};
